module.exports = __webpack_public_path__ + "static/js/unsubscriptions.f5b4dcf4.chunk.worker.js"